import React from 'react';

const OrderDownload = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_431_77)">
          <path
            d="M12.0369 15.1756C11.9243 15.1757 11.8128 15.1536 11.7088 15.1105C11.6047 15.0675 11.5102 15.0044 11.4306 14.9248C11.351 14.8451 11.2879 14.7506 11.2448 14.6466C11.2018 14.5426 11.1797 14.4311 11.1797 14.3185V1.49972C11.1797 1.27239 11.2701 1.05437 11.4308 0.893629C11.5915 0.732884 11.8096 0.642578 12.0369 0.642578C12.2642 0.642578 12.4822 0.732884 12.643 0.893629C12.8037 1.05437 12.894 1.27239 12.894 1.49972V14.3185C12.894 14.5458 12.8037 14.7638 12.643 14.9246C12.4822 15.0853 12.2642 15.1756 12.0369 15.1756Z"
            fill="#545454"
          />
          <path
            d="M12.0369 15.5608C11.7488 15.5613 11.4635 15.5048 11.1973 15.3947C10.9311 15.2845 10.6893 15.1229 10.4858 14.919L5.85653 10.2897C5.69586 10.1291 5.60559 9.91115 5.60559 9.68392C5.60559 9.45669 5.69586 9.23877 5.85653 9.07809C6.01721 8.91742 6.23513 8.82715 6.46236 8.82715C6.68959 8.82715 6.90751 8.91742 7.06819 9.07809L11.6974 13.7073C11.742 13.7519 11.7949 13.7873 11.8532 13.8114C11.9114 13.8355 11.9738 13.848 12.0369 13.848C12.0999 13.848 12.1623 13.8355 12.2206 13.8114C12.2788 13.7873 12.3317 13.7519 12.3763 13.7073L17.0056 9.07809C17.1672 8.92191 17.3837 8.83545 17.6084 8.83734C17.8331 8.83923 18.0482 8.92931 18.2071 9.08819C18.3661 9.24707 18.4563 9.46202 18.4583 9.68676C18.4603 9.9115 18.374 10.128 18.2179 10.2897L13.588 14.919C13.3844 15.1228 13.1426 15.2844 12.8764 15.3946C12.6102 15.5047 12.3249 15.5612 12.0369 15.5608Z"
            fill="#545454"
          />
          <path
            d="M21.593 23.3577H2.48077C1.8783 23.357 1.30071 23.1173 0.874702 22.6913C0.448691 22.2653 0.209039 21.6877 0.208313 21.0852V15.0935C0.208313 14.8661 0.298619 14.6481 0.459364 14.4874C0.62011 14.3266 0.838127 14.2363 1.06546 14.2363C1.29278 14.2363 1.5108 14.3266 1.67155 14.4874C1.83229 14.6481 1.9226 14.8661 1.9226 15.0935V21.0852C1.92278 21.2332 1.98165 21.3751 2.08628 21.4797C2.19092 21.5844 2.33279 21.6432 2.48077 21.6434H21.593C21.741 21.6432 21.8828 21.5844 21.9875 21.4797C22.0921 21.3751 22.151 21.2332 22.1512 21.0852V15.0935C22.1512 14.8661 22.2415 14.6481 22.4022 14.4874C22.563 14.3266 22.781 14.2363 23.0083 14.2363C23.2356 14.2363 23.4537 14.3266 23.6144 14.4874C23.7752 14.6481 23.8655 14.8661 23.8655 15.0935V21.0852C23.8647 21.6877 23.6251 22.2653 23.1991 22.6913C22.7731 23.1173 22.1955 23.357 21.593 23.3577Z"
            fill="#545454"
          />
        </g>
        <defs>
          <clipPath id="clip0_431_77">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.0368652)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default OrderDownload;
